import Head from 'next/head';
import { useRouter } from 'next/router';

import { Header } from '../../components/Header';
import { EventsPage, useConfig } from '@purple-start-registration/components';

export default function Home() {
  const router = useRouter();

  // Get the config.
  const { config_section } = router.query;
  const { config } = useConfig(config_section);

  // Get other page information.
  const language = router.query.language || 'nl';
  const title = config && config.settings[`name_${language}`];

  return (
    <>
      <Header title={title} />
      <div
        style={{
          backgroundAttachment: 'fixed',
          backgroundPosition: 'right',
          backgroundImage: 'url("/Achtergrond-ps.png")',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <div className="flex flex-col items-center justify-center min-h-screen">
          <Head>
            <title>Purple Start {title && `| ${title}`}</title>
            <link rel="icon" href="/favicon.ico" />
          </Head>
          <main className="flex flex-col items-center w-full flex-1 px-5 lg:px-20 mb-10">
            <div className="flex flex-wrap items-center justify-around max-w-4xl mt-6 sm:w-full">
              <div className="relative rounded-lg border border-gray-200 mt-5 ring-1 ring-gray-900 ring-opacity-5">
                <div className="w-full rounded-lg overflow-hidden sm:rounded-r-none">
                  {config && (
                    <div className="antialiased font-sans bg-gray-100 overflow-hidden">
                      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <EventsPage
                          config={config}
                          configSection={config_section}
                          language={language}
                          apiBaseUrl=""
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
